export class PaymentTermsRequest {
    paymentTermsId : number;
    
    constructor(paymentTermsId : number)
    {
        this.paymentTermsId = paymentTermsId;
        
    }
}
